import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize(): void {
    window.ELCO.CSRF.refreshTokens();
    this.setELCOPageData();

    window.addEventListener('turbo:load', this.onTurboLoad);
    window.addEventListener('turbo:frame-load', this.onTurboFrameLoad);
    window.addEventListener('turbo:frame-missing', this.onTurboFrameMissing);

    window.addEventListener(
      'page:loaded',
      ((e: CustomEvent) => {
        window.ELCO.Debug.debug('log', e.type, e.detail);
      }) as unknown as EventListener,
      { once: true },
    );

    window.addEventListener('page_data:updated', ((e: CustomEvent) => {
      window.ELCO.Debug.debug('log', e.type, e.detail);
    }) as unknown as EventListener);
  }

  disconnect(): void {
    window.removeEventListener('turbo:load', this.onTurboLoad);
    window.removeEventListener('turbo:frame-load', this.onTurboFrameLoad);
    window.removeEventListener('turbo:frame-missing', this.onTurboFrameMissing);
  }

  private onTurboLoad = () => {
    this.setELCOPageData();

    const pageLoaded = new CustomEvent('page:loaded', {
      detail: window.ELCO.Analytics.pageData(),
    });
    window.dispatchEvent(pageLoaded);
  };

  private onTurboFrameLoad = () => {
    this.setELCOPageData();

    const pageDataUpdated = new CustomEvent('page_data:updated', {
      detail: window.ELCO.Analytics.pageData(),
    });
    window.dispatchEvent(pageDataUpdated);
  };

  private setELCOPageData = () => {
    const element = document.querySelector('#page_data');
    window.__elco_page_data = element
      ? JSON.parse(element.innerHTML || '{}')
      : {};
  };

  private onTurboFrameMissing = () => {
    window.location.assign(window.location.href);
  };
}
